/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import ClusterBarChart from "./ClusterBarChart";

class Body extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="body__container">
        <ClusterBarChart
          data={data.growthFund}
          dataKey="year"
          clusterCategories={["revenue", "expenses", "balance"]}
          colorScheme={["#4E79A7", "#E15759", "#F28E2B"]}
          yAxisTickFormatter={format("$.2s")}
          tooltipFormatter={format("$,.0f")}
          yAxisWidth={60}
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default Body;
